import { permissionsOperations } from '@ardoq/access-control';
import { userOperations } from '@ardoq/core';
import { combineLatest, distinctUntilChanged, map } from 'rxjs';
import { toPersistentStream } from '@ardoq/rxbeach';
import { loadedCurrentUser$ } from '../streams/currentUser/currentUser$';
import { Features } from '@ardoq/features';
import { APICurrentUser } from '@ardoq/api-types';
import { sidebarScope$ } from '../appContainer/sidebarScope$';

/**
 * Returns true if the user's role restricts them to the Discover journey.
 * This does not reflect the actual journey — users with broader access (e.g.
 * admins) may also be in the Discover journey if they have entered Discover
 * scope, which is handled separately via sidebarScope$.
 */
const isRoleRestrictedToDiscoverJourney = (
  currentUser: APICurrentUser | null
): boolean => {
  if (!permissionsOperations.isUserFullyLoaded(currentUser)) {
    return false;
  }

  const isOrgContributor = userOperations.hasOrgContributorRole(currentUser);
  // We intentionally do not use `hasFeature` helper, but instead check the feature flag manually, because we want to check the feature flag in the current user state provided to this function.
  const hasDiscoverFeature = Boolean(
    currentUser.features[
      Features.DISCOVER_CORE_LANDING_PAGE_AND_NAVIGATION.persistedId
    ]
  );

  return hasDiscoverFeature && isOrgContributor;
};

export const isDiscoverJourney$ = toPersistentStream(
  'isDiscoverJourney$',
  combineLatest([loadedCurrentUser$, sidebarScope$]).pipe(
    map(
      ([currentUser, sidebarScope]) =>
        sidebarScope === 'discover' ||
        isRoleRestrictedToDiscoverJourney(currentUser)
    ),
    distinctUntilChanged()
  ),
  false
);

export const isDiscoverJourney = (): boolean => {
  return isDiscoverJourney$.state;
};
